<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card shadow-sm mb-4">
                <div class="card-header">
                    <h3 class="card-title">Detail Project</h3>
                    @if (canViewFinance && projectId) {
                        <projects-finance-authorization class="ms-auto" [projectId]="projectId" />
                    }
                    @if (canEditProject) {
                        <button
                            type="button"
                            class="btn btn-success"
                            [class.ms-auto]="!(canViewFinance && projectId)"
                            [class.ms-3]="canViewFinance && projectId"
                            (click)="goToEditProject()"
                            [disabled]="!projectId">
                            Edit Project
                        </button>
                    }
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <projects-accordion 
                                [projectId]="projectId"
                                [project]="project"
                                [readonly]="true">
                            </projects-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>